import React, { FC } from 'react';
import { Box, Button, Grid } from '@mui/material';
import onBoarding1 from '../../images/onBoarding1.png';

interface OnboardingIntroProps {
  onSkip: () => void;
  onNext: () => void;
}

export const OnboardingIntro: FC<OnboardingIntroProps> = ({
  onSkip,
  onNext,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img src={onBoarding1} width={'100%'} height={'450px'} />
        <Box
          sx={{
            position: 'absolute',
            top: '30px',
            left: '0px',
            marginTop: '10vh',
            width: '100%',
            display: 'flex',
            direction: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <iframe
            width="315"
            height="560"
            src="https://www.youtube.com/embed/Td9VJGl2ACQ"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </Box>
      </Box>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={{ position: 'absolute', bottom: '0px', width: '100%' }}
      >
        <Grid item xs={6}>
          <Button
            onClick={onSkip}
            size="large"
            sx={{ marginY: '2%', fontWeight: 'bold', width: '100%' }}
            variant="text"
          >
            OMITIR
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            onClick={onNext}
            size="large"
            sx={{ marginY: '2%', fontWeight: 'bold', width: '100%' }}
            variant="text"
          >
            SIGUIENTE
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
